/*
 * Fall sale — countdown and one-tap discount button.
 * Counts to a real end date (the same one the Shopify code expires on), so when the
 * clock runs out the bar and the block hide themselves instead of lying.
 * The code is handed to Shopify through the theme's own Discount module.
 */
(() => {
  const pad = (value) => String(value).padStart(2, '0');

  const format = (ms) => {
    const total = Math.max(0, Math.floor(ms / 1000));
    const days = Math.floor(total / 86400);
    const clock = `${pad(Math.floor((total % 86400) / 3600))}:${pad(Math.floor((total % 3600) / 60))}:${pad(total % 60)}`;
    return days > 0 ? `${days}d ${clock}` : clock;
  };

  const buttonText = (button) => button.querySelector('[data-sale-apply-text]') || button;

  const setState = (button, state) => {
    button.classList.toggle('is-applied', state === 'applied');
    button.classList.toggle('is-busy', state === 'busy');
    button.disabled = state === 'applied' || state === 'busy';
    const labels = {
      idle: button.dataset.label,
      busy: button.dataset.busyLabel,
      applied: button.dataset.appliedLabel,
      error: button.dataset.errorLabel,
    };
    buttonText(button).textContent = labels[state] || labels.idle;
  };

  const tick = () => {
    const now = Date.now();
    document.querySelectorAll('[data-sale-ends]').forEach((widget) => {
      const end = Date.parse(widget.dataset.saleEnds);
      // A blank or unreadable date hides the widget rather than showing a broken clock.
      if (Number.isNaN(end) || end - now <= 0) {
        widget.hidden = true;
        return;
      }
      const left = format(end - now);
      widget.querySelectorAll('[data-sale-clock]').forEach((output) => {
        output.textContent = left;
      });
      widget.classList.add('is-live');
    });
  };

  // Restores the applied look on a reload, so the shopper is not asked twice.
  const restore = () => {
    const Discount = window.Vinelora && window.Vinelora.Discount;
    if (!Discount) return;
    const saved = (Discount.read() || '').toUpperCase();
    document.querySelectorAll('[data-sale-apply]').forEach((button) => {
      const code = (button.dataset.saleCode || '').toUpperCase();
      if (code && saved === code) setState(button, 'applied');
    });
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-sale-apply]');
    if (!button || button.disabled) return;
    const Discount = window.Vinelora && window.Vinelora.Discount;
    const code = (button.dataset.saleCode || '').toUpperCase();
    if (!Discount || !code) return;

    setState(button, 'busy');
    await Discount.apply(code);
    const applied = (Discount.read() || '').toUpperCase() === code;
    setState(button, applied ? 'applied' : 'error');
    // The popup listens for this so it can close itself once the shopper has read the result.
    if (applied) button.dispatchEvent(new CustomEvent('rb:discount-applied', { bubbles: true }));
  });

  const start = () => {
    tick();
    restore();
    setInterval(tick, 1000);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  document.addEventListener('shopify:section:load', () => {
    tick();
    restore();
  });
})();
